import React from "react";
import "./Home.css";
import Container from "react-bootstrap/Container";

function Home() {
  return (
    <section className="home sections" id="home" aria-labelledby="home-title">
      <div className="home__backdrop" aria-hidden="true" />
      <Container className="home__container">
        <div className="hero">
          <div className="hero__text">
            <p className="hero__eyebrow">Toronto, Canada</p>
            <h1 id="home-title">Dmitry Kordik</h1>
            <p className="hero__role">Full Stack / Mobile Software Developer</p>
            <p className="hero__subtitle">
              Full-stack and mobile developer based in Toronto, experienced in shipping
              production web and mobile applications end-to-end.
            </p>
            <div className="hero__ctas">
              <a className="btn btn-warning" href="#portfolio">View Projects</a>
              <a
                className="btn btn-outline-light"
                href="/resume/Dmitry-Kordik-Resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                View Resume
              </a>
              <a className="btn btn-outline-light" href="https://www.linkedin.com/in/dmitry-kordik-b8410b19a/">LinkedIn</a>
              <a className="btn btn-outline-light" href="#contact-form">Get in touch</a>
            </div>
          </div>
          <div className="hero__visual" role="img" aria-label="Laptop displaying code on a desk" />
        </div>
        <div className="skills">
          <h2>Core technologies</h2>
          <div className="skills__tags">
            {["React", "TypeScript", "JavaScript", "React Native", "Expo", "Node.js", "Express", "Next.js", "Firebase / Firestore"].map(skill => (
              <span key={skill} className="skill-tag">{skill}</span>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
export default Home;
